import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Col from 'zignal-landscape/lib/Col';
import Modal from 'zignal-landscape/lib/Modal';
import ModalHeader from 'zignal-landscape/lib/ModalHeader';
import Loading from 'zignal-landscape/lib/Loading';
import themeable from 'zignal-landscape/lib/themeable';
import SyndicationIcon from 'zignal-landscape/lib/Icon/SyndicationIcon';
import get from 'lodash/get';

import StoriesTable from './components/StoriesTable';
import * as actions from './SyndicatedStoryModal.ducks';
import noop from 'lodash/noop';

export const mapStateToProps = (state) => ({
  isModalOpen: state.SyndicatedStoryModal.isModalOpen,
  isRestrictSearchByDates: state.SyndicatedStoryModal.isRestrictSearchByDates,
  isLoading: state.SyndicatedStoryModal.isLoading,
  stories: state.SyndicatedStoryModal.stories,
  unshownStories: state.SyndicatedStoryModal.unshownStories,
  timezone: state.AppUser.user.timezone,
  checkedStories: state.SyndicatedStoryModal.selectedStories,
  isDeleting: state.SyndicatedStoryModal.isDeleting || false
});

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class SyndicatedStoryModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleClickLinkToggleRestriction = this.handleClickLinkToggleRestriction.bind(
      this
    );
    this.addReadingList = this.addReadingList.bind(this);
    this.removeMention = this.removeMention.bind(this);
  }

  componentDidMount() {
    this.props.vent.on('removed:mention', this.removeMention);
    this.props.setProps({
      newsroomUrl: this.props.newsroomUrl,
      story: this.props.story
    });
    this.props.fetchStories();
    this.props.fetchUnshownStories();
    this.props.toggleModalVisibility();
  }

  removeMention(_type, data) {
    const dedupId = get(data, 'data.removals[0].dedup_id', undefined);
    if (dedupId) {
      this.props.removeMentionFromStore(dedupId);
    }
  }

  handleCloseModal() {
    // Check if modal is open before toggling visibility fixes this issue:
    // https://github.com/politear/zignal-enterprise/pull/447#discussion_r262260767
    if (this.props.isModalOpen) {
      this.props.toggleModalVisibility();
    }
  }

  handleClickLinkToggleRestriction() {
    this.props.toggleRestrictSearchByDates();
    this.props.fetchStories();
    this.props.fetchUnshownStories();
  }

  addReadingList(value, campaign) {
    this.props.createReadingList(value, campaign);
  }

  render() {
    const {
      styles,
      isModalOpen,
      isRestrictSearchByDates,
      isLoading,
      isDeleting,
      story,
      stories,
      removeMentions,
      timezone,
      isAbbreviatedLayoutActionsDropdown,
      getActionsDropdown,
      getBulkActionsDropdown,
      campaign,
      selectedStories,
      toggleModalVisibility,
      checkedStories,
      newsroomUrl,
      unshownStories
    } = this.props;

    return (
      <Modal
        isOpen={isModalOpen}
        size="large"
        onBackdropClick={this.handleCloseModal}
        onEscapePress={this.handleCloseModal}
      >
        <ModalHeader onClose={this.handleCloseModal}>
          <Col xs={12}>
            <div className={styles.modalTitle}>
              <span className={styles.titleIconWrapper}>
                <SyndicationIcon width="22" height="22" />
              </span>
              Syndicated Story
            </div>
          </Col>
        </ModalHeader>

        <div>
          <Col xs={12}>
            <header className={styles.storyHeader}>
              <h4 className={styles.storyHeaderTitle}>{story.title}</h4>
            </header>
          </Col>

          <Col xs={12}>
            {isLoading ? (
              <div className={styles.loadingSpinner}>
                <Loading />
              </div>
            ) : (
              <StoriesTable
                newsroomUrl={newsroomUrl}
                storiesList={stories}
                unshownStories={unshownStories}
                timezone={timezone}
                getActionsDropdown={getActionsDropdown}
                getBulkActionsDropdown={getBulkActionsDropdown}
                isAbbreviatedLayoutActionsDropdown={
                  isAbbreviatedLayoutActionsDropdown
                }
                isRestrictSearchByDates={isRestrictSearchByDates}
                isDeleting={isDeleting}
                onToggleRestriction={this.handleClickLinkToggleRestriction}
                addReadingList={this.addReadingList}
                campaign={campaign}
                selectedStories={selectedStories}
                toggleModalVisibility={toggleModalVisibility}
                removeMentions={removeMentions}
                checkedStories={checkedStories}
              />
            )}
          </Col>
        </div>
      </Modal>
    );
  }
}

SyndicatedStoryModal.propTypes = {
  checkedStories: PropTypes.array,
  styles: PropTypes.object.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  isRestrictSearchByDates: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  stories: PropTypes.array.isRequired,
  unshownStories: PropTypes.array.isRequired,
  timezone: PropTypes.string,
  toggleModalVisibility: PropTypes.func.isRequired,
  toggleRestrictSearchByDates: PropTypes.func.isRequired,
  setProps: PropTypes.func.isRequired,
  fetchStories: PropTypes.func.isRequired,
  fetchUnshownStories: PropTypes.func.isRequired,
  createReadingList: PropTypes.func,
  selectedStories: PropTypes.func,
  // Props coming from backbone
  story: PropTypes.object.isRequired,
  newsroomUrl: PropTypes.string,
  isAbbreviatedLayoutActionsDropdown: PropTypes.bool,
  getActionsDropdown: PropTypes.func,
  getBulkActionsDropdown: PropTypes.func,
  account: PropTypes.object.isRequired,
  campaign: PropTypes.object.isRequired,
  vent: PropTypes.object,
  removeMentionFromStore: PropTypes.func,
  removeMentions: PropTypes.func
};

SyndicatedStoryModal.defaultProps = {
  vent: {
    on: noop
  },
  removeMentionFromStore: noop,
  removeMentions: noop
};

export default connect(
  mapStateToProps,
  actions,
  mergeProps
)(themeable(SyndicatedStoryModal));
